export const NB_CHAT_COMMON_FILTER = 'newbuilding_chat_common_filter';
export const NB_CONSULTANT_TRIGGERING_MESSAGE = 'newbuilding-triggering-message';
export const NB_HELP_IN_SEARCH = 'newbuilding_consultant_help_in_search';
export const RENTER_FORM_EXPERIMENT = 'renter_form_experiment';
export const NEWBUILDING_SPECIAL_PROJECT = 'newbuilding_special_project';
export const AUDIENCE_ONETWOTRIP_BANNER = 'audience_onetwotrip_banner';
export const AUD_WITH_NEIGHBORS_DISABLED = 'aud_all_platform_aud2219_minus20km';
export const AUDIENCE_2023_Q1_CONTROL = 'audience_2023q1_control_experiment';
export const MORTGAGE_PROMO_DISCOUNT_CAMPAIGN = 'mortgage_promo_discount_campaign';
export const FAVORITES_FOR_AUTORISATION = 'aud_web_aud2133_favorites_for_autorisation';
export const AUD_MAP_BANNER = 'aud_desktop_aud2280_map_on_list';

export const EXPERIMENTS: string[] = [
  'newbuilding_consultant',
  NB_CHAT_COMMON_FILTER,
  NB_CONSULTANT_TRIGGERING_MESSAGE,
  NB_HELP_IN_SEARCH,
  RENTER_FORM_EXPERIMENT,
  NEWBUILDING_SPECIAL_PROJECT,
  AUDIENCE_ONETWOTRIP_BANNER,
  AUDIENCE_2023_Q1_CONTROL,
  AUD_WITH_NEIGHBORS_DISABLED,
  MORTGAGE_PROMO_DISCOUNT_CAMPAIGN,
  FAVORITES_FOR_AUTORISATION,
  AUD_MAP_BANNER,
];
